<ng-container *transloco="let t; read: 'header'">

    <ng-container *ngIf="!authenticated">
        <li *ngFor="let authType of authTypes" class="nav-item thm-sign-in">
            <!--    <thm-external-link [url]="anadoluSsoExternalLoginUrl" text="Giriş"></thm-external-link>-->
            <!-- TODO: href i olmayan a ların buttona dönüştürülmesi gerekiyor ama stilleri yok -->
            <a href="javascript:void(0)" class="nav-link" (click)="login(authType)">
                <i class="fas fa-lock" aria-hidden="true"></i> <span>{{ t('login') }}</span>
            </a>
        </li>
    </ng-container>
    <ng-container *ngIf="authenticated">
        <li class="nav-item thm-user-name">
            <a href="javascript:void(0)" class="nav-link">

                <!-- Photo Start -->
                <div class="photo">
                    <i class="fas fa-user" aria-hidden="true"></i>
                </div>
                <!-- Photo End -->

                <!-- Name Start -->
                <div class="name">
                    {{ user.firstName }} {{ user.lastName }}
                </div>
                <!-- Name End -->

            </a>
        </li>
        <li class="nav-item thm-sign-out">
            <a href="javascript:void(0)" class="nav-link" (click)="logout()">
                <i class="fas fa-unlock" aria-hidden="true"></i>
                <span class="text">
                    {{ t('logout') }}
                </span>
            </a>
        </li>
    </ng-container>

</ng-container>